module.exports = __webpack_public_path__ + "static/media/invoice_icon.c46c67b0.svg";